import { AbstractControl } from '@angular/forms';

export const fileSizeValidator = (maxSize: number) => (control: AbstractControl) => {
    const file = control.value;

    return file?.size > maxSize ? { size: true } : null;
};

export const fileTypeValidator = (types: string[]) => (control: AbstractControl) => {
    const file = control.value;

    if (file) {
        return file?.type && types.find((type) => file.type.startsWith(type)) ? null : { type: true };
    }
    return false;
};
